import React, { useState } from "react";
import { v4 as uuid } from "uuid";

import { axiosWithAuth } from "../../utils/axiosWithAuth.js";

import {
	SquarePaymentForm,
	// ApplePayButton,
	CreditCardCVVInput,
	CreditCardExpirationDateInput,
	CreditCardNumberInput,
	CreditCardPostalCodeInput,
	CreditCardSubmitButton,
	GooglePayButton,
	MasterpassButton,
} from "react-square-payment-form";
import "react-square-payment-form/lib/default.css";

const {
	REACT_APP_SQUARE_APPLICATION_ID,
	REACT_APP_SQUARE_LOCATION_ID,
} = process.env;

const Square = (props) => {

    const paymentData = props.paymentData;

	const APPLICATION_ID = REACT_APP_SQUARE_APPLICATION_ID;
	const LOCATION_ID = REACT_APP_SQUARE_LOCATION_ID;

	const [errorMessages, setErrorMessages] = useState([]);

    const [processing, setProcessing] = useState(false)

	const idempotency_key = uuid();

    const inputStyles = [{
        fontFamily: 'tahoma',
        fontSize: '15px',
        padding: '10px 2px 1px 1px',
    }]

	async function processPayment(nonce, buyerVerificationToken) {
        // console.log('processPayment', paymentData)
		const postPaymentData = {
			nonce: nonce,
			idempotency_key: idempotency_key,
			location_id: LOCATION_ID,
			// amount: '1', //set to 1 for testing -- amount is overridden by backend
			amount: paymentData.total,
			buyerEmailAddress: paymentData.email,
			statementDescriptionIdentifier: "ItsAGoodLifeFitness",
			buyerVerificationToken: buyerVerificationToken,
			lineItems: paymentData.items,
			first_name: paymentData.first_name,
			last_name: paymentData.last_name,
			company_name: paymentData.company_name,
			address_1: paymentData.address_1,
			address_2: paymentData.address_2,
			city: paymentData.city,
			state: paymentData.state,
			postal_code: paymentData.postal_code,
			phone: paymentData.phone
		};

		axiosWithAuth()
			.post("/square/payment", postPaymentData)
			.then((res) => {
				// console.log(res.data);
                setProcessing(false)
                props.onApprove(res.data.payment);
			})
			.catch((err) => {
				console.log("ERROR", err.response);
                setErrorMessages(["Error processing payment", err.response.data.message[0].detail ?? err.message]);
                setProcessing(false)
			});
	}

	function cardNonceResponseReceived(
		errors,
		nonce,
		cardData,
		buyerVerificationToken
	) {
		if (errors) {
			setErrorMessages(errors.map((error) => error.message));
			return;
		}

		setErrorMessages([]);
		processPayment(nonce, buyerVerificationToken);
	}

    //For Apple Pay Etc
	function createPaymentRequest() {
		// console.log(paymentData.total)
		return {
			requestShippingAddress: false,
			requestBillingInfo: true,
			currencyCode: "USD",
			countryCode: "US",
			total: {
				label: "It's a Good Life Fitness",
				amount: `${paymentData.total}`,
				pending: false,
			},
			lineItems: paymentData.items
		};
	}

	function createVerificationDetails() {
        setProcessing(true)
		return {
			amount: paymentData.total, //must be string, square format 
			currencyCode: "USD",
			intent: "CHARGE",
			billingContact: {
				familyName: paymentData.last_name,
				givenName: paymentData.first_name,
				email: paymentData.email,
				country: "US",
				city: paymentData.city,
				addressLines: [paymentData.address_1, paymentData.address_2],
				postalCode: paymentData.postal_code,
				phone: paymentData.phone,
			},
		};
	}

	function postalCode() {
		const postalCode = paymentData.postal_code; // your logic here
		return postalCode;
	}

	function focusField() {
		return "cardNumber";
	}

	const loadingView = <div className="sq-wallet-loading"></div>;
	// const unavailableApple = (
	// 	<div className="sq-wallet-unavailable">
	// 		Apple pay unavailable. Open safari on desktop or mobile to use.
	// 	</div>
	// );
	const unavailableGoogle = (
		<div className="sq-wallet-unavailable">Google pay unavailable.</div>
	);
	const unavailableMasterpass = (
		<div className="sq-wallet-unavailable">Masterpass unavailable.</div>
	);

	return (
		<SquarePaymentForm
			// sandbox={true}
			applicationId={APPLICATION_ID}
			locationId={LOCATION_ID}
			cardNonceResponseReceived={cardNonceResponseReceived}
			createPaymentRequest={createPaymentRequest}
			createVerificationDetails={createVerificationDetails}
			postalCode={postalCode}
			focusField={focusField}
            inputStyles={inputStyles}
		>
			<fieldset className="sq-fieldset">
				<CreditCardNumberInput />
                
                <div className="sq-thirds">
                    <div className="sq-exp-ccv">                    
                        <div className="sq-form-third">
                            <CreditCardExpirationDateInput />
                        </div>

                        <div className="sq-form-third">
                            <CreditCardCVVInput />
                        </div>
                    </div>
                    <div className="sq-postal">
                        <CreditCardPostalCodeInput />
                    </div>
                </div>
			</fieldset>

			<CreditCardSubmitButton>{processing ? (<>Processing...</>):(<>Pay ${props.buttonTotal}.00</>)}</CreditCardSubmitButton>

            <div className="sq-error-message">
				{errorMessages.map((errorMessage) => (
					<li key={`sq-error-${errorMessage}`}>{errorMessage}</li>
				))}
			</div>

			<div className="sq-divider">
				<span className="sq-divider-label">Or</span>
				<hr className="sq-divider-hr" />
			</div>
{/* 
			<ApplePayButton
				loadingView={loadingView}
				unavailableView={unavailableApple}
			/> */}
			<GooglePayButton
				loadingView={loadingView}
				unavailableView={unavailableGoogle}
			/>
			<MasterpassButton
				loadingView={loadingView}
				unavailableView={unavailableMasterpass}
			/>
		</SquarePaymentForm>
	);
};

export default Square;
